import React from 'react';
import styled from 'astroturf/react';
import { Colors } from 'js/design_system/Color';
import AccountOutlineIcon from 'js/svg/colorless/account_outline.svg';
import DeleteOutlineIcon from 'js/svg/colorless/delete_outline.svg';
import LeftCarotIcon from 'js/design_system/icons/navigate_before.svg';
import RepostIcon from 'js/design_system/icons/repeat.svg';
import PencilIcon from 'js/svg/colorless/pencil.svg';
import _ThinnerIconSpan from "Icons-ThinnerIconSpan.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/Icons.tsx?styleId=ThinnerIconSpan";


const ThinnerIconSpan = /*#__PURE__*/styled("span", null, {
  displayName: "ThinnerIconSpan",
  styles: _ThinnerIconSpan
});

type SvgSizes = 12 | 16 | 20;

type ThinnerIconProps = React.PropsWithChildren<{ size?: SvgSizes }>;

const ThinnerIcon = ({ size, children }: ThinnerIconProps) => (
  <ThinnerIconSpan style={{ width: size, height: size }}>
    {children}
  </ThinnerIconSpan>
);
export const FollowInactive: React.FC<{ size?: SvgSizes }> = ({ size }) => (
  <ThinnerIcon size={size || 20}>
    <AccountOutlineIcon color={Colors.GrayDark} />
  </ThinnerIcon>
);
export const DeleteInactive: React.FC<{ size?: SvgSizes }> = ({ size }) => (
  <ThinnerIcon size={size || 20}>
    <DeleteOutlineIcon color={Colors.GrayDark} />
  </ThinnerIcon>
);
export const LeftArrow: React.FC<{ size?: SvgSizes }> = ({ size }) => (
  <ThinnerIcon size={size || 20}>
    <LeftCarotIcon color={Colors.PrimaryBlue} />
  </ThinnerIcon>
);
export const Repost: React.FC<{ size?: SvgSizes }> = ({ size }) => (
  <ThinnerIcon size={size || 20}>
    <RepostIcon color={Colors.GrayDark} />
  </ThinnerIcon>
);
export const Edit: React.FC<{ size?: SvgSizes }> = ({ size }) => (
  <ThinnerIcon size={size || 20}>
    <PencilIcon color={Colors.GrayDark} />
  </ThinnerIcon>
);

export const NoThumbnailIconOld: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width={56}
      height={72}
      viewBox="0 0 56 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.5 1H19L54.6835 1.00002V17.7252V70.56H1V18.5L18.5 1Z"
        fill="white"
        stroke="#DDDDE2"
      />
      <path
        d="M18.2708 1.01815L18.7708 1.01815C18.7708 0.816011 18.6491 0.63376 18.4624 0.556306C18.2757 0.478854 18.0607 0.52144 17.9177 0.66422L18.2708 1.01815ZM1 18.2527L0.646819 17.8988C0.503602 18.0417 0.460631 18.2568 0.53796 18.4438C0.615288 18.6308 0.797673 18.7527 1 18.7527L1 18.2527ZM18.2708 18.2527L18.2708 18.7527L18.7708 18.7527L18.7708 18.2527L18.2708 18.2527ZM17.9177 0.66422L0.646819 17.8988L1.35318 18.6066L18.624 1.37207L17.9177 0.66422ZM1 18.7527L18.2708 18.7527L18.2708 17.7527L1 17.7527L1 18.7527ZM18.7708 18.2527L18.7708 1.01815L17.7708 1.01815L17.7708 18.2527L18.7708 18.2527Z"
        fill="#DDDDE2"
      />
      <path
        d="M7.11612 24.9463H47.5603"
        stroke="#B1B1BA"
        strokeLinecap="round"
      />
      <path d="M25 13.2802H47.7498" stroke="#B1B1BA" strokeLinecap="round" />
      <path
        d="M7.11612 36.6125H47.5603"
        stroke="#B1B1BA"
        strokeLinecap="round"
      />
      <path
        d="M7.11612 48.2787H47.5603"
        stroke="#B1B1BA"
        strokeLinecap="round"
      />
      <path
        d="M7.11612 59.9449H47.5603"
        stroke="#B1B1BA"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const NoThumbnailIcon: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width={56}
      height={72}
      viewBox="0 0 56 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Apply horizontal mirror by using transform="scale(-1,1) translate(-56,0)" */}
      <g transform="scale(-1,1) translate(-56,0)">
        <path
          d="M18.5 1H19L54.6835 1.00002V17.7252V70.56H1V18.5L18.5 1Z"
          fill="white"
          stroke="#DDDDE2"
        />
        <path
          d="M18.2708 1.01815L18.7708 1.01815C18.7708 0.816011 18.6491 0.63376 18.4624 0.556306C18.2757 0.478854 18.0607 0.52144 17.9177 0.66422L18.2708 1.01815ZM1 18.2527L0.646819 17.8988C0.503602 18.0417 0.460631 18.2568 0.53796 18.4438C0.615288 18.6308 0.797673 18.7527 1 18.7527L1 18.2527ZM18.2708 18.2527L18.2708 18.7527L18.7708 18.7527L18.7708 18.2527L18.2708 18.2527ZM17.9177 0.66422L0.646819 17.8988L1.35318 18.6066L18.624 1.37207L17.9177 0.66422ZM1 18.7527L18.2708 18.7527L18.2708 17.7527L1 17.7527L1 18.7527ZM18.7708 18.2527L18.7708 1.01815L17.7708 1.01815L17.7708 18.2527L18.7708 18.2527Z"
          fill="#DDDDE2"
        />
        <path d="M25 10H47.7498" stroke="#B1B1BA" strokeLinecap="round" />
        <path d="M25 18.5H47.7498" stroke="#B1B1BA" strokeLinecap="round" />
        <path d="M7.11612 27H47.5603" stroke="#B1B1BA" strokeLinecap="round" />
        <path
          d="M7.11612 35.5H47.5603"
          stroke="#B1B1BA"
          strokeLinecap="round"
        />
        <path d="M7.11612 44H47.5603" stroke="#B1B1BA" strokeLinecap="round" />
        <path
          d="M7.11612 52.5H47.5603"
          stroke="#B1B1BA"
          strokeLinecap="round"
        />
        <path d="M7.11612 61H47.5603" stroke="#B1B1BA" strokeLinecap="round" />
      </g>
    </svg>
  );
};

export const CheckIcon: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      width={14}
      height={11}
      viewBox="0 0 14 11"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.74999 8.15001L1.59999 5.00001L0.549988 6.05001L4.74999 10.25L13.75 1.25001L12.7 0.200012L4.74999 8.15001Z" />
    </svg>
  );
};

export const WhiteCheckIcon: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width={15}
      height={12}
      viewBox="0 0 14 11"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.74999 8.15001L1.59999 5.00001L0.549988 6.05001L4.74999 10.25L13.75 1.25001L12.7 0.200012L4.74999 8.15001Z" />
    </svg>
  );
};

export const GreenCheckIcon: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width={14}
      height={11}
      viewBox="0 0 14 11"
      fill="#035C0F"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.74999 8.15001L1.59999 5.00001L0.549988 6.05001L4.74999 10.25L13.75 1.25001L12.7 0.200012L4.74999 8.15001Z" />
    </svg>
  );
};

export const ImageIcon: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.25 12.25H1.75V1.75H12.25M12.25 0.25H1.75C1.35218 0.25 0.970644 0.408035 0.68934 0.68934C0.408035 0.970644 0.25 1.35218 0.25 1.75V12.25C0.25 12.6478 0.408035 13.0294 0.68934 13.3107C0.970644 13.592 1.35218 13.75 1.75 13.75H12.25C12.6478 13.75 13.0294 13.592 13.3107 13.3107C13.592 13.0294 13.75 12.6478 13.75 12.25V1.75C13.75 1.35218 13.592 0.970644 13.3107 0.68934C13.0294 0.408035 12.6478 0.25 12.25 0.25ZM8.47 7.2175L6.4075 9.8725L4.9375 8.1025L2.875 10.75H11.125L8.47 7.2175Z" />
    </svg>
  );
};

export const MultiDotMore: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width="14"
      height="4"
      viewBox="0 0 14 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.99992 3.66659C1.54159 3.66659 1.14936 3.50325 0.823252 3.17658C0.496585 2.85047 0.333252 2.45825 0.333252 1.99992C0.333252 1.54159 0.496585 1.14909 0.823252 0.822419C1.14936 0.496307 1.54159 0.333252 1.99992 0.333252C2.45825 0.333252 2.85047 0.496307 3.17659 0.822419C3.50325 1.14909 3.66659 1.54159 3.66659 1.99992C3.66659 2.45825 3.50325 2.85047 3.17659 3.17658C2.85047 3.50325 2.45825 3.66659 1.99992 3.66659ZM6.99992 3.66659C6.54158 3.66659 6.14936 3.50325 5.82325 3.17658C5.49659 2.85047 5.33325 2.45825 5.33325 1.99992C5.33325 1.54159 5.49659 1.14909 5.82325 0.822419C6.14936 0.496307 6.54158 0.333252 6.99992 0.333252C7.45825 0.333252 7.85075 0.496307 8.17742 0.822419C8.50353 1.14909 8.66658 1.54159 8.66658 1.99992C8.66658 2.45825 8.50353 2.85047 8.17742 3.17658C7.85075 3.50325 7.45825 3.66659 6.99992 3.66659ZM11.9999 3.66659C11.5416 3.66659 11.1491 3.50325 10.8224 3.17658C10.4963 2.85047 10.3333 2.45825 10.3333 1.99992C10.3333 1.54159 10.4963 1.14909 10.8224 0.822419C11.1491 0.496307 11.5416 0.333252 11.9999 0.333252C12.4583 0.333252 12.8508 0.496307 13.1774 0.822419C13.5035 1.14909 13.6666 1.54159 13.6666 1.99992C13.6666 2.45825 13.5035 2.85047 13.1774 3.17658C12.8508 3.50325 12.4583 3.66659 11.9999 3.66659Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};

export const PaperIcon: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      width={12}
      height={16}
      viewBox="0 0 12 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.5 0.5C1.10218 0.5 0.720644 0.658035 0.43934 0.93934C0.158035 1.22064 0 1.60218 0 2V14C0 14.3978 0.158035 14.7794 0.43934 15.0607C0.720644 15.342 1.10218 15.5 1.5 15.5H10.5C10.8978 15.5 11.2794 15.342 11.5607 15.0607C11.842 14.7794 12 14.3978 12 14V5L7.5 0.5H1.5ZM1.5 2H6.75V5.75H10.5V14H1.5V2ZM3 8V9.5H9V8H3ZM3 11V12.5H6.75V11H3Z" />
    </svg>
  );
};

export const InversePaperIcon: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width={12}
      height={16}
      viewBox="0 0 12 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.5 15.5C1.0875 15.5 0.7345 15.3533 0.441 15.0597C0.147 14.7657 0 14.4125 0 14V2C0 1.5875 0.147 1.23425 0.441 0.94025C0.7345 0.64675 1.0875 0.5 1.5 0.5H7.5L12 5V14C12 14.4125 11.8533 14.7657 11.5597 15.0597C11.2657 15.3533 10.9125 15.5 10.5 15.5H1.5ZM6.75 5.75H10.5L6.75 2V5.75Z" />
    </svg>
  );
};

export const InfoIcon: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" />
    </svg>
  );
};

export const TimesIcon: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.8 11.25L0.75 10.2L4.95 6L0.75 1.8L1.8 0.75L6 4.95L10.2 0.75L11.25 1.8L7.05 6L11.25 10.2L10.2 11.25L6 7.05L1.8 11.25Z" />
    </svg>
  );
};

export const SearchIcon: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14.3333 15.5L9.08333 10.25C8.66667 10.5833 8.1875 10.8472 7.64583 11.0417C7.10417 11.2361 6.52778 11.3333 5.91667 11.3333C4.40278 11.3333 3.12167 10.8092 2.07333 9.76083C1.02444 8.71194 0.5 7.43056 0.5 5.91667C0.5 4.40278 1.02444 3.12139 2.07333 2.0725C3.12167 1.02417 4.40278 0.5 5.91667 0.5C7.43056 0.5 8.71194 1.02417 9.76083 2.0725C10.8092 3.12139 11.3333 4.40278 11.3333 5.91667C11.3333 6.52778 11.2361 7.10417 11.0417 7.64583C10.8472 8.1875 10.5833 8.66667 10.25 9.08333L15.5 14.3333L14.3333 15.5ZM5.91667 9.66667C6.95833 9.66667 7.84389 9.30222 8.57333 8.57333C9.30222 7.84389 9.66667 6.95833 9.66667 5.91667C9.66667 4.875 9.30222 3.98944 8.57333 3.26C7.84389 2.53111 6.95833 2.16667 5.91667 2.16667C4.875 2.16667 3.98944 2.53111 3.26 3.26C2.53111 3.98944 2.16667 4.875 2.16667 5.91667C2.16667 6.95833 2.53111 7.84389 3.26 8.57333C3.98944 9.30222 4.875 9.66667 5.91667 9.66667Z" />
    </svg>
  );
};

export const GraduationCapIcon: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width={15}
      height={12}
      viewBox="0 0 15 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.33333 0L0 4L2.66667 5.45333V9.45333L7.33333 12L12 9.45333V5.45333L13.3333 4.72667V9.33333H14.6667V4L7.33333 0ZM11.88 4L7.33333 6.48L2.78667 4L7.33333 1.52L11.88 4ZM10.6667 8.66667L7.33333 10.48L4 8.66667V6.18L7.33333 8L10.6667 6.18V8.66667Z" />
    </svg>
  );
};

export const TagIcon: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11.4961 5.75391C11.6875 5.97266 11.8242 6.27344 11.8242 6.57422C11.8242 6.90234 11.7148 7.20312 11.4961 7.39453L7.39453 11.4961C7.20312 11.7148 6.90234 11.8242 6.57422 11.8242C6.27344 11.8242 5.97266 11.7148 5.75391 11.4961L0.503906 6.24609C0.285156 6.02734 0.175781 5.72656 0.175781 5.42578V1.32422C0.175781 0.695312 0.695312 0.175781 1.32422 0.175781H5.42578C5.72656 0.175781 6.02734 0.285156 6.24609 0.503906L11.4961 5.75391ZM6.57422 10.6758L10.6758 6.57422L5.42578 1.32422H1.32422V5.42578L6.57422 10.6758ZM1.92578 2.80078C1.92578 3.26562 2.30859 3.67578 2.80078 3.67578C3.26562 3.67578 3.67578 3.26562 3.67578 2.80078C3.67578 2.30859 3.26562 1.92578 2.80078 1.92578C2.30859 1.92578 1.92578 2.30859 1.92578 2.80078Z" />
    </svg>
  );
};

export const AccountMultipleOutline: React.FC<React.SVGAttributes<SVGElement>> =
  (props) => {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M13.07 10.4101C13.6774 9.56132 14.0041 8.54377 14.0041 7.50005C14.0041 6.45634 13.6774 5.43879 13.07 4.59005C13.6385 4.20201 14.3117 3.99622 15 4.00005C15.9283 4.00005 16.8185 4.3688 17.4749 5.02518C18.1313 5.68156 18.5 6.57179 18.5 7.50005C18.5 8.42831 18.1313 9.31855 17.4749 9.97493C16.8185 10.6313 15.9283 11.0001 15 11.0001C14.3117 11.0039 13.6385 10.7981 13.07 10.4101ZM5.5 7.50005C5.5 6.80782 5.70527 6.13113 6.08986 5.55556C6.47444 4.97998 7.02107 4.53138 7.66061 4.26647C8.30015 4.00157 9.00388 3.93226 9.68282 4.0673C10.3617 4.20235 10.9854 4.5357 11.4749 5.02518C11.9644 5.51466 12.2977 6.1383 12.4327 6.81724C12.5678 7.49617 12.4985 8.1999 12.2336 8.83944C11.9687 9.47899 11.5201 10.0256 10.9445 10.4102C10.3689 10.7948 9.69223 11.0001 9 11.0001C8.07174 11.0001 7.1815 10.6313 6.52513 9.97493C5.86875 9.31855 5.5 8.42831 5.5 7.50005ZM7.5 7.50005C7.5 7.79672 7.58797 8.08673 7.7528 8.33341C7.91762 8.58008 8.15189 8.77234 8.42597 8.88587C8.70006 8.9994 9.00166 9.02911 9.29264 8.97123C9.58361 8.91335 9.85088 8.77049 10.0607 8.56071C10.2704 8.35093 10.4133 8.08366 10.4712 7.79269C10.5291 7.50172 10.4994 7.20012 10.3858 6.92603C10.2723 6.65194 10.08 6.41767 9.83335 6.25285C9.58668 6.08803 9.29667 6.00005 9 6.00005C8.60218 6.00005 8.22064 6.15809 7.93934 6.43939C7.65804 6.7207 7.5 7.10223 7.5 7.50005ZM16 17.0001V19.0001H2V17.0001C2 17.0001 2 13.0001 9 13.0001C16 13.0001 16 17.0001 16 17.0001ZM14 17.0001C13.86 16.2201 12.67 15.0001 9 15.0001C5.33 15.0001 4.07 16.3101 4 17.0001M15.95 13.0001C16.5629 13.4768 17.064 14.0819 17.4182 14.7729C17.7723 15.4639 17.9709 16.2241 18 17.0001V19.0001H22V17.0001C22 17.0001 22 13.3701 15.94 13.0001H15.95Z" />
      </svg>
    );
  };

export const HiddenIcon: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.66671 4.39168L2.73337 3.33334L16.6667 17.2667L15.6084 18.3333L13.0417 15.7667C12.0834 16.0833 11.0667 16.25 10 16.25C5.83337 16.25 2.27504 13.6583 0.833374 10C1.40837 8.53334 2.32504 7.24168 3.49171 6.21668L1.66671 4.39168ZM10 7.50001C10.6631 7.50001 11.299 7.7634 11.7678 8.23224C12.2366 8.70108 12.5 9.33697 12.5 10C12.5 10.2917 12.45 10.575 12.3584 10.8333L9.16671 7.64168C9.42504 7.55001 9.70837 7.50001 10 7.50001ZM10 3.75001C14.1667 3.75001 17.725 6.34168 19.1667 10C18.4834 11.7333 17.325 13.2333 15.8334 14.325L14.65 13.1333C15.7834 12.35 16.7167 11.2833 17.35 10C15.975 7.20001 13.1334 5.41668 10 5.41668C9.09171 5.41668 8.20004 5.56668 7.36671 5.83334L6.08337 4.55834C7.28337 4.04168 8.60837 3.75001 10 3.75001ZM2.65004 10C4.02504 12.8 6.86671 14.5833 10 14.5833C10.575 14.5833 11.1417 14.525 11.6667 14.4083L9.76671 12.5C8.57504 12.375 7.62504 11.425 7.50004 10.2333L4.66671 7.39168C3.84171 8.10001 3.15004 8.98334 2.65004 10Z" />
    </svg>
  );
};

export const Close: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill="currentColor"
      {...props}
    >
      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
    </svg>
  );
};

export const WindowClose: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M13.46 12L19 17.54V19H17.54L12 13.46L6.46 19H5V17.54L10.54 12L5 6.46V5H6.46L12 10.54L17.54 5H19V6.46L13.46 12Z" />
    </svg>
  );
};

export const BlockIcon: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
    >
      <path d="M9.99996 1.66663C14.5833 1.66663 18.3333 5.41663 18.3333 9.99996C18.3333 14.5833 14.5833 18.3333 9.99996 18.3333C5.41663 18.3333 1.66663 14.5833 1.66663 9.99996C1.66663 5.41663 5.41663 1.66663 9.99996 1.66663ZM9.99996 3.33329C8.41663 3.33329 6.99996 3.83329 5.91663 4.74996L15.25 14.0833C16.0833 12.9166 16.6666 11.5 16.6666 9.99996C16.6666 6.33329 13.6666 3.33329 9.99996 3.33329ZM14.0833 15.25L4.74996 5.91663C3.83329 6.99996 3.33329 8.41663 3.33329 9.99996C3.33329 13.6666 6.33329 16.6666 9.99996 16.6666C11.5833 16.6666 13 16.1666 14.0833 15.25Z" />
    </svg>
  );
};

export const AddPersonInactive: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
    >
      <path d="M12.5 3.33334C11.616 3.33334 10.7681 3.68453 10.143 4.30965C9.5179 4.93478 9.16671 5.78262 9.16671 6.66668C9.16671 7.55073 9.5179 8.39858 10.143 9.0237C10.7681 9.64882 11.616 10 12.5 10C13.3841 10 14.2319 9.64882 14.8571 9.0237C15.4822 8.39858 15.8334 7.55073 15.8334 6.66668C15.8334 5.78262 15.4822 4.93478 14.8571 4.30965C14.2319 3.68453 13.3841 3.33334 12.5 3.33334ZM12.5 4.91668C13.4667 4.91668 14.25 5.70001 14.25 6.66668C14.25 7.63334 13.4667 8.41668 12.5 8.41668C12.0359 8.41668 11.5908 8.2323 11.2626 7.90411C10.9344 7.57592 10.75 7.13081 10.75 6.66668C10.75 6.20255 10.9344 5.75743 11.2626 5.42924C11.5908 5.10105 12.0359 4.91668 12.5 4.91668ZM3.33337 5.83334V8.33334H0.833374V10H3.33337V12.5H5.00004V10H7.50004V8.33334H5.00004V5.83334H3.33337ZM12.5 10.8333C10.275 10.8333 5.83337 11.9417 5.83337 14.1667V16.6667H19.1667V14.1667C19.1667 11.9417 14.725 10.8333 12.5 10.8333ZM12.5 12.4167C14.975 12.4167 17.5834 13.6333 17.5834 14.1667V15.0833H7.41671V14.1667C7.41671 13.6333 10 12.4167 12.5 12.4167Z" />
    </svg>
  );
};

export const FlagInactive: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.3 5.00001L10.6333 6.66668H15V11.6667H12.2L11.8666 10H5.83329V5.00001H10.3ZM11.6666 3.33334H4.16663V17.5H5.83329V11.6667H10.5L10.8333 13.3333H16.6666V5.00001H12" />
    </svg>
  );
};

export const FolderInactive: React.FC<React.SVGAttributes<SVGElement>> = (
  props,
) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.6666 15H3.33329V6.66665H16.6666M16.6666 4.99998H9.99996L8.33329 3.33331H3.33329C2.40829 3.33331 1.66663 4.07498 1.66663 4.99998V15C1.66663 15.442 1.84222 15.8659 2.15478 16.1785C2.46734 16.4911 2.89127 16.6666 3.33329 16.6666H16.6666C17.1087 16.6666 17.5326 16.4911 17.8451 16.1785C18.1577 15.8659 18.3333 15.442 18.3333 15V6.66665C18.3333 5.74165 17.5833 4.99998 16.6666 4.99998Z" />
    </svg>
  );
};
